export const TWITTER_URL = 'https://twitter.com/Coinowl_io?s=20';
export const TELEGRAM_URL = 'https://t.me/coinowldao';
export const ABOUT_US = `Coinowl is a frontrunner that helps to get all the trending and upcoming projects in crypto space with detailed tokenomics and vesting schedules`;
export const ONGOING_IDO = 'OnGoing';
export const PAST_IDO = 'Past';
export const UPCOMING_IDO = 'UpComming';
export const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;
export const COOKIE_CONSENT =
  'This website uses cookies for functionality, analytics. If you continue to use this site you agree to the usage of cookies.';
